import React from 'react'

import './loading.less';

const LoadingGif = () => {
  return (
    <div className="loading"></div>
  )
}

export default LoadingGif;